import { useEffect } from 'react';
import { useConversation } from '../../contexts/conversation';
import { InputType } from '../../enums/conversation';
import { useNativeFooter } from '../../hooks/useNativeFooter';
import { taraStatus } from '../../utils/conversation';
import logger from '../../utils/logger';
import { taraPwaHelper } from '../../utils/pwa';
import TextInput from '../ChatInput/Text';

function ChatFooter() {
    const { isValidPwa } = taraPwaHelper;
    const { conversation, input, sendMessage } = useConversation();
    const { disableActions, enableActions, mount, unmount } = useNativeFooter();

    const handleVideoEvents = (msg: MessageEvent) => {
        if (msg.data?.type !== 'taraMessageVideo') return;

        logger({ id: 'BRIDGE-EVENT-CALLBACK', type: 'info', data: msg.data });

        const value = msg.data?.query;
        if (!value) return;

        const messageParts = [
            {
                isPrivate: false,
                text: {
                    content: value,
                },
            },
        ];

        if (msg.data?.mode === 'TEXT') {
            taraStatus.disable();
            sendMessage({ messageParts, input: value, mode: msg.data.mode });
            return;
        }

        taraStatus.introduce();
        taraStatus.enable();
        sendMessage({ messageParts, input: value, mode: msg.data?.mode });
    };

    useEffect(() => {
        if (!isValidPwa) return () => {};

        window.addEventListener('message', handleVideoEvents);
        return () => {
            window.removeEventListener('message', handleVideoEvents);
            unmount();
        };
    }, []);

    useEffect(() => {
        if (!isValidPwa) return;

        if (conversation?.isAgentActive) {
            unmount();
            return;
        }

        mount();
    }, [conversation?.isAgentActive]);

    useEffect(() => {
        if (!isValidPwa) return;

        if (input?.type === InputType.TEXT) {
            enableActions();
            return;
        }

        disableActions();
    }, [input?.type]);

    if (conversation?.isAgentActive || (!isValidPwa && input?.type === InputType.TEXT)) return <TextInput />;

    return null;
}

export default ChatFooter;
